export function formatarPercentualTaxa(percentual) {
  const numero = Number(percentual)
  if (!Number.isFinite(numero)) return '0%'
  const texto = Number.isInteger(numero) ? String(numero) : String(numero).replace('.', ',')
  return `${texto}%`
}

function toNumber(value) {
  const parsed = Number(String(value ?? '').replace(',', '.'))
  return Number.isFinite(parsed) ? parsed : 0
}

export function taxasParceladoDaConfig(taxaCliente) {
  const raw = taxaCliente?.parceladas ?? taxaCliente?.taxas_parcelado
  if (raw == null || raw === '') return []
  if (Array.isArray(raw)) return raw
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      return Array.isArray(parsed) ? parsed : []
    } catch {
      return []
    }
  }
  return []
}

export function formatarTaxaParceladoCliente(taxas) {
  const itens = taxasParceladoDaConfig({ parceladas: taxas })
    .map((item) => {
      const parcela = item?.parcela
      const taxa = item?.taxa
      if (parcela == null || taxa == null) return null
      return `${parcela}x: ${taxa}%`
    })
    .filter(Boolean)
  return itens.length > 0 ? itens.join(' | ') : '-'
}

/**
 * 1x → taxa à vista da configuração.
 * 2x+ → taxa da tabela parcelada (parcela exata ou a maior parcela <= N).
 */
export function percentualTaxaCliente(taxaCliente, parcela) {
  if (!taxaCliente) return 0

  const parcelaNum = Number(parcela ?? 1)
  const avista = toNumber(taxaCliente.taxa_avista ?? taxaCliente.percentual)

  if (!Number.isFinite(parcelaNum) || parcelaNum <= 1) {
    return avista > 0 ? avista : 0
  }

  const tabela = taxasParceladoDaConfig(taxaCliente)
  if (tabela.length > 0) {
    const taxaExata = tabela.find((item) => Number(item?.parcela) === parcelaNum)
    if (taxaExata) {
      const taxa = toNumber(taxaExata?.taxa)
      return taxa > 0 ? taxa : 0
    }

    const taxasAteParcela = tabela
      .filter((item) => Number(item?.parcela) > 1 && Number(item?.parcela) <= parcelaNum)
      .sort((a, b) => Number(b?.parcela) - Number(a?.parcela))
    if (taxasAteParcela.length > 0) {
      const taxa = toNumber(taxasAteParcela[0]?.taxa)
      return taxa > 0 ? taxa : 0
    }
  }

  return avista > 0 ? avista : 0
}

export function opcoesSelectTaxaCliente(taxas = []) {
  return (taxas || []).map((taxa) => ({
    value: taxa.id,
    label: taxa.nome,
    nome: taxa.nome,
    taxa_avista: toNumber(taxa.taxa_avista ?? taxa.percentual),
    parceladas: taxasParceladoDaConfig(taxa)
  }))
}

/** Mantém os percentuais do snapshot e casa o value com a opção da lista (react-select). */
export function valorSelectTaxaCliente(selecionada, opcoes = []) {
  if (!selecionada) return null
  const daLista = (opcoes || []).find((o) => String(o.value) === String(selecionada.value))
  if (!daLista) return selecionada
  return {
    ...daLista,
    label: selecionada.label || daLista.label,
    nome: selecionada.nome || daLista.nome,
    taxa_avista: selecionada.taxa_avista ?? daLista.taxa_avista,
    parceladas: selecionada.parceladas ?? daLista.parceladas
  }
}

export function snapshotTaxaClienteDoPagamento(pagamento) {
  const raw = pagamento?.taxa_cliente_snapshot ?? pagamento?.taxaClienteSnapshot
  if (raw == null || raw === '') return null
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw)
      return parsed && typeof parsed === 'object' ? parsed : null
    } catch {
      return null
    }
  }
  return typeof raw === 'object' ? raw : null
}

export function montarTaxaClienteOptionFromApi(taxa) {
  if (!taxa) return null
  const opcoes = opcoesSelectTaxaCliente([taxa])
  return opcoes[0] || null
}

export function montarTaxaClienteOptionFromPagamento(pagamento) {
  const snapshot = snapshotTaxaClienteDoPagamento(pagamento)
  if (snapshot) {
    const live = pagamento?.taxa_cliente || pagamento?.taxaCliente
    const id = snapshot.id ?? snapshot.value ?? live?.id ?? live?.value
    return {
      value: id,
      label: snapshot.nome || live?.nome || live?.label || 'Taxa cliente',
      nome: snapshot.nome || live?.nome || live?.label,
      taxa_avista: toNumber(snapshot.taxa_avista ?? snapshot.percentual),
      parceladas: taxasParceladoDaConfig(snapshot)
    }
  }
  return montarTaxaClienteOptionFromApi(pagamento?.taxa_cliente || pagamento?.taxaCliente)
}

const CONFIG_HISTORICA_TAXA_CLIENTE = {
  taxa_avista: 5,
  parceladas: [{ parcela: 2, taxa: 15 }]
}

export function formaPagamentoTemTaxaCliente(forma) {
  const flag = forma?.pag_credito ?? forma?.pagCredito
  if (flag != null && String(flag).trim() !== '') {
    return String(flag).trim().toUpperCase() === 'SIM'
  }
  return Number(forma?.pag_idtipo) === 3
}

export function percentualTaxaClienteDoPagamento(pagamento) {
  const forma = pagamento?.formaPagamento || pagamento?.forma
  if (!formaPagamentoTemTaxaCliente(forma)) return 0
  const snapshot = snapshotTaxaClienteDoPagamento(pagamento)
  const config = snapshot || pagamento?.taxaCliente
  const parcela = pagamento?.parcela?.value ?? pagamento?.pag_idparcela ?? 1
  if (config) {
    const pct = percentualTaxaCliente(config, parcela)
    if (pct > 0) return pct
  }
  return percentualTaxaCliente(CONFIG_HISTORICA_TAXA_CLIENTE, parcela)
}

export function taxaClientePadrao(opcoes = []) {
  const lista = opcoes || []
  return (
    lista.find((o) => String(o.nome || o.label || '').toLowerCase() === 'padrão') ||
    lista[0] ||
    null
  )
}

export function taxaClienteEfetiva(taxaCliente, forma, opcoes = []) {
  if (!formaPagamentoTemTaxaCliente(forma)) return null
  if (taxaCliente) return valorSelectTaxaCliente(taxaCliente, opcoes)
  return taxaClientePadrao(opcoes) || { ...CONFIG_HISTORICA_TAXA_CLIENTE, label: 'Padrão', nome: 'Padrão' }
}
